import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IMyCompanySite} from "../../../../../../utils/interfaces/my_company/my_company_site/IMyCompanySite";


const useApiGetMyCompanySite = (pk: number | undefined): UseQueryResult<IMyCompanySite, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, pk: number | undefined): Promise<IMyCompanySite> {
        try {
            const response = await get(`/api/company/${company_token}/my_company/my_company_site/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetMyCompanySite", pk],
        queryFn: () => doGet(selectedCompany?.company_token, pk),
        enabled: !!pk,
    })

};

export default useApiGetMyCompanySite